/**
 * @generated SignedSource<<eaa43e7a7e422d159eb16df5aeeba83a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventCardPresentationsSection_event$data = {
  readonly eventCardPresentations: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
      readonly node: {
        readonly guestPresenterAvatarUrl: string;
        readonly presenter: {
          readonly firstName: string;
          readonly lastName: string;
          readonly " $fragmentSpreads": FragmentRefs<"UserPrimaryPhoto_user">;
        } | null | undefined;
        readonly presenterFirstName: string | null | undefined;
        readonly presenterLastName: string | null | undefined;
        readonly rowId: string;
      };
    }>;
    readonly totalCount: number;
  };
  readonly " $fragmentType": "EventCardPresentationsSection_event";
};
export type EventCardPresentationsSection_event$key = {
  readonly " $data"?: EventCardPresentationsSection_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventCardPresentationsSection_event">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventCardPresentationsSection_event",
  "selections": [
    {
      "alias": "eventCardPresentations",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 3
        },
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": [
            "CREATED_AT_ASC",
            "ID_ASC"
          ]
        }
      ],
      "concreteType": "PresentationsConnection",
      "kind": "LinkedField",
      "name": "presentations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PresentationsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Presentation",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "rowId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "presenterFirstName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "presenterLastName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "transform",
                      "value": {
                        "dpr": 3,
                        "fo": "auto",
                        "h": 32,
                        "w": 32
                      }
                    }
                  ],
                  "kind": "ScalarField",
                  "name": "guestPresenterAvatarUrl",
                  "storageKey": "guestPresenterAvatarUrl(transform:{\"dpr\":3,\"fo\":\"auto\",\"h\":32,\"w\":32})"
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "User",
                  "kind": "LinkedField",
                  "name": "presenter",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "UserPrimaryPhoto_user"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        }
      ],
      "storageKey": "presentations(first:3,orderBy:[\"CREATED_AT_ASC\",\"ID_ASC\"])"
    }
  ],
  "type": "Event",
  "abstractKey": null
};

(node as any).hash = "094ed0cdd36966ae7c4a8f32d1b95a9f";

export default node;
